export default __webpack_public_path__ + "static/media/Sensei1.78712131.jpeg";